import React from 'react';
var Rank = function (_a) {
    var _b;
    var rank = _a.rank;
    if (!rank) {
        return null;
    }
    var RANK_COLORS = ['#CCAD08', '#C0C0C0', '#B08D57', '#4F2303', '#922724'];
    return (React.createElement("div", { style: { display: 'flex', justifyContent: 'center', alignItems: 'flex-start', fontWeight: 700, fontSize: 50, color: (_b = RANK_COLORS[rank - 1]) !== null && _b !== void 0 ? _b : 'white', textShadow: "-1px -1px 0 #FFF, 1px -1px 0 #FFF, -1px 1px 0 #FFF, 1px 1px 0 #FFF" } }, rank));
};
export default Rank;
